module.exports = __webpack_public_path__ + "static/media/main_bg.639621e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/main_bg.png
// module id = 334
// module chunks = 0